(function () {
  var cardSelector = '.kuProdWrap';
  var initializedAttribute = 'data-product-card-swiper-initialized';
  var observer = null;

  function initializeProductCardSwiper(productCard) {
    if (!productCard || productCard.hasAttribute(initializedAttribute) || typeof window.Swiper === 'undefined') {
      return;
    }

    if (productCard.closest('.companion-carousel--standard-cards')) {
      return;
    }

    var overlay = productCard.querySelector('.catalog-product-overlay');
    var thumbnails = productCard.querySelectorAll('.card-thumbnail img[data-image-src]');

    if (!overlay || thumbnails.length < 2) {
      return;
    }

    if (overlay.querySelector('.product-swiper')) {
      productCard.setAttribute(initializedAttribute, 'true');
      return;
    }

    var swiperContainer = document.createElement('div');
    var swiperWrapper = document.createElement('div');

    swiperContainer.className = 'swiper product-swiper';
    swiperWrapper.className = 'swiper-wrapper';

    thumbnails.forEach(function (thumbnail) {
      var slide = document.createElement('div');
      var image = document.createElement('img');

      slide.className = 'swiper-slide';
      image.src = thumbnail.dataset.imageSrc;
      image.loading = 'lazy';
      image.alt = thumbnail.alt || '';
      slide.appendChild(image);
      swiperWrapper.appendChild(slide);
    });

    swiperContainer.appendChild(swiperWrapper);
    overlay.appendChild(swiperContainer);

    var swiper = new Swiper(swiperContainer, {
      allowTouchMove: true,
      cssMode: false,
      freeMode: false,
      grabCursor: true,
      lazy: true,
      loop: true,
      preloadImages: false,
      resistanceRatio: 0.5,
      slidesPerGroup: 1,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      threshold: 20
    });

    function updateActiveThumbnail() {
      thumbnails.forEach(function (thumbnail, index) {
        thumbnail.closest('.card-thumbnail').classList.toggle('is-active', swiper.realIndex === index);
      });
    }

    swiper.on('slideChange', updateActiveThumbnail);
    updateActiveThumbnail();

    thumbnails.forEach(function (thumbnail, index) {
      function goToSlide(event) {
        if (event.type === 'click') {
          event.preventDefault();
          event.stopPropagation();
        }

        swiper.slideToLoop(index);
        updateActiveThumbnail();
      }

      thumbnail.addEventListener('mouseenter', goToSlide);
      thumbnail.addEventListener('click', goToSlide);
    });

    productCard.setAttribute(initializedAttribute, 'true');
  }

  function initializeProductCardSwipers(root) {
    var scope = root || document;
    var parentCard = scope.closest && scope.closest(cardSelector);

    if (parentCard) {
      initializeProductCardSwiper(parentCard);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(cardSelector).forEach(initializeProductCardSwiper);
    }
  }

  function observeProductCards() {
    if (observer || !document.body || typeof MutationObserver === 'undefined') {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            initializeProductCardSwipers(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    initializeProductCardSwipers(document);
    observeProductCards();
  }

  window.initializeProductCardSwipers = initializeProductCardSwipers;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
